/**
 * Shared 18+ affirmation microcopy, shown at the point of a SIGN UP action.
 *
 * This is the informed, affirmative 18+ consent that pairs with any
 * `<GoogleAuthButton attestOver18 />` one-tap signup (and the email signup
 * form). It explicitly states "18 or older" at the point of the action and is
 * never a pre-checked box.
 *
 * Rendered on BOTH the signup page (SignupStep1) and the homepage hero
 * (AnonymousHero) so every Google signup entry point carries identical consent
 * wording and identical /terms + /privacy link targets. Keeping the wording in
 * this single component is what keeps the two surfaces from drifting apart.
 *
 * `id` is optional so the same copy can appear on more than one surface without
 * risking a duplicate element id. `className` / `style` let each caller fit the
 * affirmation to its layout (text alignment, hero drop-shadow) without changing
 * the wording or link targets.
 */
const SignupAgeAffirmation = ({ id, className = "", style }) => (
  <p
    id={id}
    style={style}
    className={`text-xs leading-relaxed text-muted-foreground ${className}`.trim()}
  >
    By continuing, you confirm you are 18 or older and agree to our{" "}
    <a
      href="/terms"
      target="_blank"
      rel="noreferrer"
      className="text-primary underline underline-offset-2"
    >
      Official Rules, Terms
    </a>
    , and{" "}
    <a
      href="/privacy"
      target="_blank"
      rel="noreferrer"
      className="text-primary underline underline-offset-2"
    >
      Privacy Policy
    </a>
    .
  </p>
);

export default SignupAgeAffirmation;
